<template>
  <md-field md-clearable @md-clear="clearValue" class="md-invalid date-range">
    <div class="w-full relative cursor-pointer">
      <div class="w-full h-full flex">
        <label>{{ label }}</label>
        <md-input
          :disabled="disabled"
          v-model="displayValue"
          :required="required"
          readonly
        ></md-input>
        <slot></slot>
      </div>
      <date-picker
        :disabled="disabled"
        :disabled-date="disabledDate"
        v-model="dateRangePicker"
        range
        :format="formatDateClient"
        valueType="format"
        @change="changeValue($event)"
        class="date-range-picker"
        ref="dateRangePicker"
      ></date-picker>
    </div>
  </md-field>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  convertDateFromServer,
  convertDateSendServer,
  formatDateClient
} from "@/helpers/datetime-helper";

export default {
  name: "date-range-picker",
  components: { DatePicker },
  props: {
    label: String,
    required: {
      type: Boolean,
      default: false
    },
    value: Array,
    disabled: {
      type: Boolean,
      default: false
    },
    disabledDate: {
      type: Function,
      default: () => {}
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      dateRangePicker: convertDateFromServer(this.value, "date-range"),
      formatDateClient
    };
  },
  computed: {
    displayValue: {
      get: function() {
        return this.dateRangePicker.join(` ${this.$t("common.to")} `);
      },
      set: function(value) {
        return value;
      }
    }
  },
  methods: {
    changeValue(newValue) {
      if (newValue.some(date => date !== null)) {
        const dateSendServer = convertDateSendServer(newValue, "date-range");
        this.$emit("change", dateSendServer);
      } else {
        this.clearValue();
      }
    },
    clearValue() {
      this.dateRangePicker = [];
      this.$emit("change", []);
    }
  }
};
</script>
<style lang="scss">
.date-range {
  &-picker {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100% !important;

    input.mx-input {
      background: transparent;
      border: 0;
      box-shadow: none;
      color: transparent;
      cursor: pointer;
    }
    .mx-icon-clear {
      color: transparent;
    }
  }

  .md-error {
    top: 35px;
  }

  button[disabled="disabled"].md-clear {
    display: none;
  }
}
</style>
